var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturnBookBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_44_810",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_44_810",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAC20lEQVR4nO2dv4rVQBSHP1dQFO0E17uWyj6CjWClsqC1lW+gwtrca2FlbSOCgmCnD2KhlhcE8Q22c8HdZf9YaJEELtfkJmZmzsmf3wcHloFJznwZJpPDTRaEEEIIIYQQYkTcAd4BP4B94E8PYx/4CjwBzsbVE84m8Al/SbFjDlyN6CmIW8Au/lJSynaf2ZsMW3IRj2MJa8sQl4uy+BJLWBtuVyQ1xPgVImotpDPwILB/n7gY0jlU9M3A/qPhVGD/PeBCjER6QmtfoTPaUvIxMAM28pjlbaPA6kZ0DNwvOf9d4NAwDzc8JRdYynbDW3KBlWw3uiC5wEK2G12RXJBathtdklyQUrYbXZNckEq2G12UXJBCthuxBnAEbCXIbys/tkTnMa05z6qLUHeBZhHzdCPWANZXnKNYAqqoW3IuR8zTjdSiF9fZVTmskj2JmKcbsQYwKzn28vpal0PVOv8sYp5uxBpAUZm7kseMf29iTXI4KjnOccQ8WxNaj7a8ylW5diGHWkLr0aIhEm2ERBsh0UZItBESbYREGyHRRki0ERJthEQb0SfRk5K2DfMsWtIn0Q8btg2SWOXHpqXUKdnMnuR/xyyBqkzaIVQm7ToSbYREGyHRRki0EX0SfUK2pVt8h+XENSNDLPewZT8bmxrn0Jo+7aMnwM5S23pJW0pGsY8uG+Rp8yxa0ifRqnUYhWodI2IUa3SvkWgjJLo5rh9GGRPfQzpLdHM+hHTWrqMZc+AGAbUVzeh65sA9nAtYlg8LlrEHfAYeAWei2QqgKtFDYJvV7w+K/6BK9LZnUkOkSrRm8hKhN0PLWnCvCa3nXqL8I4M7OH/Lc2icJ3s0LbsZPiV7e1VE4j3+27GUsQu8Bs7FEtaW62SbeW8hqeNtLGEhPMdfROo4oANP0mvAR/xlDF40ZDuYF8Bv/KWkiDfxVMXhGvAS+EZ//z3IYvwEXtGBm6EQQgghhBBCJOEvOPIjysZXTF4AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnBookBlack);
export default __webpack_public_path__ + "static/media/return_book_black.00e1f2da459302c9be2c4595788c039e.svg";
export { ForwardRef as ReactComponent };